import React from 'react';
import Building from "../../../components/pages/grid/Building/Building";

const BuildingGridPage = () => {
    return <Building />
};

export default BuildingGridPage;
